import {
    createContext,
    type Dispatch,
    type SetStateAction,
    useContext,
} from "react";

interface CustomerViewContextValue {
    // When true, an elevated user (manager/admin) is viewing the portal as a
    // CUSTOMER of the currently selected company. Drives the effective role on
    // the frontend and the view-as header sent to the backend.
    isCustomerView: boolean;
    setIsCustomerView: Dispatch<SetStateAction<boolean>>;
}

const CustomerViewContext = createContext<CustomerViewContextValue>({
    isCustomerView: false,
    setIsCustomerView: () => {},
});
const CustomerViewProvider = CustomerViewContext.Provider;
const useCustomerViewContext = () => useContext(CustomerViewContext);

export { CustomerViewContext, CustomerViewProvider, useCustomerViewContext };
